<template>
  <div class="container" v-if="loading">
    <div class="loader"></div>
  </div>
  <router-view :mfaToken="mfaToken" :authenticatorList="authenticatorList" :state="state" v-else />
</template>

<script>
import 'url-search-params-polyfill';

export default {
  name: 'App',
  data: () => ({
    loading: true,
    mfaToken: null,
    authenticatorList: null,
    state: null
  }),
  async mounted() {
    try {
      this.state = new URLSearchParams(window.location.search).get('state');
      const isAuthenticated = await window.auth.isAuthenticated();
      const profile = await window.auth.getProfile();
      if (!isAuthenticated || profile.email_verified === false) {
        return window.location.replace(process.env.VUE_APP_ID_PROFILE_URL);
      }
      this.mfaToken = await window.auth.getAccessTokenDifferentAudience({ scope: 'read:authenticators remove:authenticators enroll', audience: `${process.env.VUE_APP_MFA_URL}mfa/` });

      const response = await fetch(`${process.env.VUE_APP_MFA_URL}mfa/authenticators`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.mfaToken}`
        }
      });
      if (!response.ok) {
        throw new Error('Cannot get authenticators')
      }
      this.authenticatorList = await response.json();

      // Don't start enroll if already enrolled
      if (this.authenticatorList.findIndex(auth => auth.active) > -1) {
        if (profile['http://arduino.cc/enforce_mfa']) {
          return window.location.replace(process.env.VUE_APP_ID_PROFILE_URL);
        } else {
          // If user got valid authenticator but not the metada, set the metada then exit ( this may not happen )
          const token = await window.auth.getAccessToken();
          const userApiResponse = await fetch(`${process.env.VUE_APP_API_URL}/users/v1/users/byID/me/mfa`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({})
          });
          if (!userApiResponse.ok) {
            throw new Error('Something went wrong, please contact the support');
          }
          return window.location.replace(process.env.VUE_APP_ID_PROFILE_URL);
        }
      }
      this.loading = false;
    } catch (e) {
      this.$toasted.show(e)
    }
  }
};
</script>
